import Vue from "vue";
import VueSignaturePad from "vue-signature-pad";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import lodash from "lodash";
import moment from "moment";
import Header from "./components/elements/Header.vue";
import Sidemenu from "./components/elements/Sidemenu.vue";
import wysiwyg from "vue-wysiwyg";
import { Tabs, Tab } from "vue-tabs-component";
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import "firebase/compat/auth";

import VueLodash from "vue-lodash";
import VueMoment from "vue-moment";
import VueSweetalert2 from "vue-sweetalert2";
// import CKEditor from "@ckeditor/ckeditor5-vue";
import VueGoogleCharts from "vue-google-charts";

import VueCkeditor from "vue-ckeditor5";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import AxiosPlugin from "vue-axios-cors";

Vue.use(AxiosPlugin);

Vue.use(VueSignaturePad);

const ckoptions = {
  editors: {
    classic: ClassicEditor,
  },
  name: "ckeditor",
};

Vue.use(VueCkeditor.plugin, ckoptions);
Vue.component("tabs", Tabs);
Vue.component("tab", Tab);
Vue.component("page-header", Header);
Vue.component("side-menu", Sidemenu);

Vue.use(require("vue-moment"));

require("@/assets/fonts/family=Sofiapro-100,200,300,400,500,600,700,900.css");
require("@/assets/fonts/family=TTNorms-300,400,500,600,700.css");

Vue.use(VueGoogleCharts);

(Vue.prototype.$last = function(item, list) {
  return item === list[list.length - 1];
}),
  Vue.filter("capitalize", function(value) {
    if (!value) return "";
    value = value.toString();
    return value.charAt(0).toUpperCase() + value.slice(1);
  }),
  (Vue.prototype.$first = function(item, list) {
    return item === list[0];
  }),
  (Vue.config.productionTip = false);

Vue.use(wysiwyg, {
  hideModules: {
    image: true,
    table: true,
    headings: true,
    code: true,
    orderedList: true,
    unorderedList: true,
    removeFormat: true,
    table: true,
    separator: true,
  },
  maxHeight: "100px",
});

Vue.use(VueSweetalert2);

router.beforeEach((to, from, next) => {
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.title);
  if (nearestWithTitle) document.title = nearestWithTitle.meta.title;

  if (to.path == "/response") {
    // console.log("Response pagina");
    next();
  } else if (to.path == "/unsubscribe") {
    // console.log("Unsubscribe pagina");
    next();
  } else if (to.path == "/relplayer") {
    // console.log("relplayer pagina");
    next();
  } else {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        // console.log("Firestore token aanwezig: ", to.path, to.query);
        store.dispatch("tryAutoLogin", user).then(() => {
          if (
            to.path == "/login" &&
            to.query &&
            to.query.d &&
            to.query.d != "login"
          ) {
            // console.log("login + query no login: ",  to.path, to.query)
            next("/" + to.query.d);
          } else if (to.path == "/login" && to.query && to.query.d == "login") {
            // console.log("login + query with login: ",  to.path, to.query)
            next("/home");
          } else if (to.path == "/login") {
            // console.log("login")
            next("/home");
          } else {
            // console.log("geen login")
            next();
          }
        });
      } else {
        console.log("Firestore token niet aanwezig");
        if (to.path == "/login") {
          next();
        } else {
          let path = window.location.pathname.substr(1);
          // console.log("Path: ", path)
          next("/login?d=" + path);
        }
      }
    });
  }
});

export const bus = new Vue();

Vue.prototype._ = lodash;

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
